import { EventHandler, FC, MouseEvent as ReactMouseEvent, useRef } from 'react'
import { Link, LinkProps } from 'react-router-dom'
import { buildAbsoluteMedicareMyUrl } from 'utils/urls/buildAbsoluteMedicareMyUrl'
import { MyLinkClickHandler, MyLinkSiteActivityProps, MyLinkSiteActivityPropsV2, sendLinkSiteActivity } from './MyLink'

export type MyInternalLinkProps = Omit<LinkProps, 'to' | 'onClick'> & {
  onClick?: MyLinkClickHandler
  siteActivityProps?: MyLinkSiteActivityProps | MyLinkSiteActivityPropsV2,
  to: string
}

export const MyInternalLink: FC<MyInternalLinkProps> = ({ siteActivityProps, onClick, ...props }) => {
  const ref = useRef<HTMLAnchorElement>(null)
  const handleClick: EventHandler<ReactMouseEvent<HTMLAnchorElement, MouseEvent>> = (event) => {
    sendLinkSiteActivity(siteActivityProps)
    onClick?.({
      linkUrl: buildAbsoluteMedicareMyUrl(props.to.toString()),
      linkText: ref.current?.innerText
    })
  }

  return <Link ref={ref} onClick={handleClick} {...props} />
}
